import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import CreatePublicityCampaign from './create'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'

import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import FilterListIcon from '@mui/icons-material/FilterList'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'
import IndianaScroller from 'react-indiana-drag-scroll'

import Table from '../../components/MUITable'
import money from '../../components/Money'



const PublicityCampaignsToolbar = (props) => {
  const { maxLen, current, selected, add, remove, clean, edit, vendor, } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected.id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)

  const [cleanDialog, setCleanDialog] = React.useState(false)
  const cleanConfirmation = () => setCleanDialog(true)
  const confirmClean = () => clean() || setCleanDialog(false)
  const closeClean = () => setCleanDialog(false)

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Costos de publicidad
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
      </Typography>
      {current && current.id && 
        <Tooltip title="Editar">
          <IconButton onClick={() => edit(current.id)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      }
      {selected && selected.length > 0 && selected.length < maxLen &&
        <Tooltip title="Eliminar">
          <IconButton onClick={deleteConfirmation}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      }
      
      <Tooltip title="Añadir publicidad">
        <IconButton onClick={add} disabled={!vendor}>
          <AddIcon />
          {!vendor && "Seleccione un canal de venta"}
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

const PublicityCampaigns = () => {
  const { vendor,  } = React.useContext(AppContext)
  const SalesChannel = React.useContext(SalesChannelsContext)
  const { current } = SalesChannel
  const { publicityCampaigns, clean, remove, detail } = SalesChannel.publicityCampaigns
  const [open, setOpen] = React.useState(false)
  const [selected, setSelected] = React.useState([])


  const removeCampaigns = () => {
    remove(selected)
  }

  const openD = (s) => {
    setOpen(true)
  }

  const closeForm = () => {
    setOpen(false)
    detail(null)
    setSelected([])
  }


  React.useEffect(() => {
    if(selected.length == 1)
      detail(publicityCampaigns.find(p => selected.includes(p.id)))
    else
      detail(null)

  }, [selected])
  return (
    <IndianaScroller>
    <Stack sx={{ width: '90vw', }} >
      <PublicityCampaignsToolbar maxLen={(publicityCampaigns && publicityCampaigns.length) || 0} vendor={vendor} selected={selected} current={current} add={openD} edit={openD} remove={removeCampaigns} clean={clean}/>
      <Paper sx={{ padding: "30px",  height:'80vh', display: 'flex', flexDirection: 'column' }}>
        <Table
            model={selected}
            setmodel={setSelected}
            data={publicityCampaigns || []}
            columns={[
              {flex: 1, headerName: "Fecha", field: "date"},
              {flex: 1, headerName: "Cliente", field: "client",
                valueGetter: (value, row) => row.client && row.client.name
              },
              {flex: 1, headerName: "Costo", field: "cost",
                valueGetter: (value, row) => money.format(Number(row.cost))
              },
              {flex: 2, headerName: "Descripcion", field: "description"},
              {flex: 1, headerName: "Canal", field: "vendor"},
            ]}
            options={{
              selection: true,
              pageSizes:[5, 10,25,50,100,250,500]
            }}
            sx={{
              '& .MuiDataGrid-cellContent': {
              overflow: 'scroll',
              textOverflow: 'unset',
              }
            }}
          />
      </Paper>
      <CreatePublicityCampaign open={open} model={current} close={closeForm}/>
    </Stack>
    </IndianaScroller>
  )
}
export default PublicityCampaigns